import { render, staticRenderFns } from "./EDMSDocument.vue?vue&type=template&id=5d5fe26b&scoped=true&"
import script from "./EDMSDocument.vue?vue&type=script&lang=js&"
export * from "./EDMSDocument.vue?vue&type=script&lang=js&"
import style0 from "./EDMSDocument.vue?vue&type=style&index=0&id=5d5fe26b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d5fe26b",
  null
  
)

export default component.exports